// extracted by mini-css-extract-plugin
module.exports = {"img":"ConsignmentPods_img__2oEBm","documentControl":"ConsignmentPods_documentControl__28rMz"};